const combineArraysWithPrefix = (arrays, prefix) => {
  if (arrays.length === 0) {
    return [prefix]
  } else {
    const first = arrays[0]
    const rest = arrays.slice(1)
    return first.flatMap(item => combineArraysWithPrefix(rest, [...prefix, item]))
  }
}

export const combineArrays = (...arrays) => {
  return combineArraysWithPrefix(arrays, [])
}
